// extracted by mini-css-extract-plugin
export var ButtonPersonalization = "doc-module--ButtonPersonalization--13b9f";
export var ButtonsPrevNext = "doc-module--ButtonsPrevNext--4fcf1";
export var DocWrapper = "doc-module--DocWrapper--15621";